// Aviso de que una pantalla cambió de nombre. Va DENTRO de la pantalla, que es
// donde el usuario aterriza y necesita confirmar que es la de siempre — poner el
// nombre viejo entre paréntesis en la etiqueta del menú lo trunca en la barra
// lateral, justo donde tendría que leerse.
//
// Se descarta por usuario y por pantalla: quien ya lo leyó no vuelve a verlo.
// Para retirarlo del todo, borrar el componente y sus usos (ver scripts 745 y 757).
// Vive en components/ui porque lo usan varios módulos: Financiero, Control
// Bancario y Contabilidad.
import { useState } from 'react';
import { Info, X } from 'lucide-react';

// `texto` es opcional y sirve para los casos que NO son un renombre —una pantalla
// que absorbió a otra, por ejemplo—, donde la frase por defecto mentiría.
export function AvisoRenombre({ clave, antes, texto }: { clave: string; antes: string; texto?: React.ReactNode }) {
  const llave = `renombre_visto_${clave}`;
  const [oculto, setOculto] = useState(() => {
    try { return localStorage.getItem(llave) === '1'; } catch { return false; }
  });
  if (oculto) return null;

  const cerrar = () => {
    try { localStorage.setItem(llave, '1'); } catch { /* modo privado: se vuelve a ver */ }
    setOculto(true);
  };

  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-sm">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
      <p className="min-w-0 flex-1">
        {texto ?? <>Es la misma pantalla de siempre: antes se llamaba <b>«{antes}»</b>.</>}
      </p>
      <button onClick={cerrar} className="rounded p-0.5 text-muted-foreground hover:bg-muted"
        title="No volver a mostrar">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
